<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz19-1"><a id="page_7"></a><a href="#/contents#RR_17" id="CC_17"> Lady Shoplifter’s Chocolate Nonfat Milkshake</a></p>
<p class="tx6" id="pz19-3"><i> Keeps you light on your feet. </i></p>
<p class="tx5" id="pz19-4"><b> 1 pint chocolate nonfat yogurt or ice cream </b></p>
<p class="tx5" id="pz19-5"><b> 4 cups nonfat milk (3 if you like it thick) </b></p>
<p class="tx5" id="pz19-6"><b> 8 heaping tablespoons chocolate Ovaltine </b></p>
<p class="tx1" id="pz19-7"><span class="dcap">B</span>lend ingredients until you can drink mixture through a straw. If you can’t drink it all, put it in a plastic cup and freeze it. It tastes good that way, too.</p>
<p class="tx" id="pz19-8"> Serves 4 to 6.</p>
<p class="txrr" id="pz19-9"> <i>Sam Bobrick—Writer</i></p>
<div class="image" id="pz19-10">
<p class="ser"><img alt="images/img-19-1.jpg" id="z19-10" src="images/img-19-1.jpg"/></p>
<p class="txcc" id="pz19-11"> <i>Down the stretch</i></p>
</div>
<p class="line"></p>
<p class="tx3k" id="pz19-12">GREAT MOMENTS </p>
<p class="tx11" id="pz19-13"> Among the most popular episodes written by Sam Bobrick and partner Bill Idelson are “The Shoplifters” (Episode #117), “A Deal Is a Deal” (Episode #122), “Barney and Thelma Lou, Phfft!” (Episode #126), “Barney’s Bloodhound” (Episode #128), “Barney Fife, Realtor” (Episode #143), and “Goober Takes a Car Apart” (Episode #144).</p>
<p class="line"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter17.vue?141899f4